import SkeletonBase from "newui/components/Skeleton";
import { LeadRevisionsView } from "./components/LeadRevisionsView";
import { PanelRevisionsView } from "./components/PanelRevisionsView";

interface RevisionsStepProps {
	evaluationId?: number;
	isLoading?: boolean;
	isRfxLead?: boolean;
	rfxId: number;
	rfxSubmissionId?: number;
}

export const RevisionsStep: React.FC<RevisionsStepProps> = ({
	rfxId,
	evaluationId,
	rfxSubmissionId,
	isRfxLead = false,
	isLoading = false,
}) => {
	if (isLoading) {
		return (
			<div className="space-y-3">
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
			</div>
		);
	}

	if (!evaluationId) {
		return (
			<div data-testid="revisions-step">
				<div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm">
					Evaluation must be started before revisions are available.
				</div>
			</div>
		);
	}

	if (isRfxLead) {
		return (
			<div data-testid="revisions-step">
				<LeadRevisionsView
					rfxId={rfxId}
					evaluationId={evaluationId}
				/>
			</div>
		);
	}

	return (
		<div data-testid="revisions-step">
			<PanelRevisionsView
				rfxId={rfxId}
				evaluationId={evaluationId}
			/>
		</div>
	);
};
